import React from 'react';
/**
 * @typedef CustomOptions
 * @property {Reference} reference;
 *
 * @typedef Reference
 * @property {string} uid;
 * @property {string} _content_type_uid;
 *
 * @param {{options: CustomOptions}} props
 */

const CustomSection = ({ options }) => {
	// const uid = options.reference[0].uid;
	// const contentType = options.reference[0]._content_type_uid;

	return (
		<div className="custom-section">
			{/* No ledger right now */}
			{/* {contentType === 'ledger' && <Ledger uid={uid} contentType={contentType} />} */}
		</div>
	);
};

export default CustomSection;
